module.exports = __webpack_public_path__ + "static/media/Path_2.4d51d95a.png";